import React, { useState, useEffect } from "react";
import WhatsAppModal from "../WhatsAppFlotante/WhatsAppModal";
import { saveTrackingParams } from "../../utils/utmTracker";
import { saveUtmParams, getCurrentUrlWithUtmDefaults } from "../../config/whatsappConfig";

const FinancingCard = ({
  banco,
  logo,
  color,
  etiquetas,
  titulo,
  tasa,
  tasaDestacada,
  detalle,
  detalleDestacado,
  link,
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Simula el submit del modal (puedes personalizarlo)
  const handleModalSubmit = async (values) => {
    setLoading(true);
    // Aquí podrías enviar los datos a tu backend o analytics
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
      // Construir la URL con TODOS los UTMs del link de llegada
      saveTrackingParams();
      saveUtmParams();
      const urlWithUtm = getCurrentUrlWithUtmDefaults();

      // Construir el mensaje de WhatsApp
      const whatsappMessage = `Hola, me gustaría hacer una consulta.\n${urlWithUtm}`;
      const encodedMessage = encodeURIComponent(whatsappMessage);
      window.location.href = `https://api.whatsapp.com/send?phone=5493513525903&text=${encodedMessage}`;
    }, 1000);
  };

  const cardContent = (
    <>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
        {logo && <img src={logo} alt={banco} style={{ height: 36, marginRight: 8 }} />}
      </div>
      <div style={{ marginBottom: 12, display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {etiquetas &&
          etiquetas.map((et, i) => (
            <span
              key={i}
              style={{
                background: "#888",
                color: "#fff",
                borderRadius: 8,
                padding: "4px 12px",
                marginRight: 8,
                fontWeight: 500,
                paddingTop: 10,
                paddingBottom: 10,
                fontSize: isMobile ? 12 : 13,
              }}
            >
              {et}
            </span>
          ))}
        {tasaDestacada && (
          <span
            style={{
              background: "#a21546",
              color: "#fff",
              borderRadius: 8,
              padding: "4px 12px",
              fontWeight: 700,
              paddingTop: 10,
              paddingBottom: 10,
              fontSize: isMobile ? 12 : 13,
            }}
          >
            {tasaDestacada}
          </span>
        )}
      </div>
      <div style={{ marginBottom: 12, display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center" }}>
        <span style={{ fontSize: isMobile ? 14 : 16 }}>{titulo}</span>
        {tasa && <span style={{ fontWeight: 700, fontSize: isMobile ? 15 : 17 }}>{tasa}</span>}
        {detalle && <span style={{ fontSize: isMobile ? 15 : 17 }}>{detalle}</span>}
        {detalleDestacado && <span style={{ fontWeight: 700, fontSize: isMobile ? 13 : 15 }}>{detalleDestacado}</span>}
      </div>
      <div>
        <button
          onClick={() => setOpen(true)}
          style={{
            color: "#a21546",
            fontWeight: 500,
            fontSize: isMobile ? 14 : 16,
            textDecoration: "none",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
          }}
        >
          Consultá ahora <span style={{ fontSize: isMobile ? 16 : 17, marginLeft: 4 }}>→</span>
        </button>
      </div>
    </>
  );

  return (
    <div
      style={{
        boxShadow: "0 4px 8px rgba(0,0,0,0.12)",
        borderRadius: 16,
        padding: 24,
        background: "#fff",
        border: "1px solid #eee",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {cardContent}
      <WhatsAppModal open={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} loading={loading} />
    </div>
  );
};

export default FinancingCard;

